import React from 'react';
import { CardContent, CardContentProps } from '@mui/material';

type UnpaddedCardContentProps = CardContentProps & {
  padded: boolean;
};

/**
 * @param padded toggle the default padding
 */
export const PaddedCardContent = ({ padded = true, ...props }: UnpaddedCardContentProps) => {
  return (
    <CardContent
      sx={{
        ...(!padded && { p: 0, '&:last-child': { pb: 0 } }),
      }}
      {...props}
    />
  );
};
